export enum ToastType {
  success = 'success',
  error = 'error',
}
